<!-- <template>
  <div class="call-me">
    <div class="t1">「 关注我们  更多福利 」</div>
    <div class="flex-s">
      <div >
      <img src="../assets/img/qr.jpg" alt="" class="erweima">
      <div class="t2">微信公众号</div>
      </div>
      <div >
      <img src="../assets/img/qr1.jpg" alt="" class="erweima">
      <div class="t2">信速察视频</div>
    </div>
    <div>
      <img src="../assets/img/qr2.png" alt="" class="erweima">
      <div class="t2">中启联信科技集团抖音</div>
    </div>
    <div>
      <img src="../assets/img/qr3.png" alt="" class="erweima">
      <div class="t2">中启联信科技集团小红书</div>
    </div>
    </div>
  </div>
</template>
<script>

</script>
<style lang="scss" scoped>
.call-me {
  height: calc(100vh - 216px);
  width: 100%;
  background: #fff;
  .t1{
    font-size: 40px;
    font-weight: 400;
    text-align: center;
    padding-top: 40px;
    padding-top: 200px;
    margin-bottom: 100px;
  }
  .flex-s{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .t2{
    font-size: 24px;
    text-align: center;
  }
}
</style> -->

<template>
  <div class="contact-page">
    <div class="page-header">
      <h1>联系我们</h1>
      <p>欢迎通过以下方式与我们取得联系，我们将尽快回复您的咨询</p>
    </div>

    <div class="contact-container">
      <div class="contact-card">
        <div class="icon-wrapper">
          <img src="../assets/img/callus/tel.png" alt="电话图标" />
        </div>
        <h3>联系方式</h3>
        <div class="info-content">
          <p class="main-info">电话：0591-38205606</p>
          <p class="main-info">手机：198 9055 5005</p>
          <p class="sub-info">工作时间: 周一至周五 9:00-18:00</p>
        </div>
        <span class="action-link clickable" @click="noAction">
          立即拨打
          <img src="../assets/img/callus/mouse.png" alt="点击图标" class="mouse-icon" />
        </span>
      </div>

      <div class="contact-card">
        <div class="icon-wrapper">
          <img src="../assets/img/callus/email.png" alt="邮箱图标" />
        </div>
        <h3>电子邮箱</h3>
        <div class="info-content">
          <p class="main-info">market@zqlinx.com</p>
          <p class="sub-info">我们将尽快回复您的邮件</p>
        </div>
        <span class="action-link clickable" @click="noAction">
          发送邮件
          <img src="../assets/img/callus/mouse.png" alt="点击图标" class="mouse-icon" />
        </span>
      </div>

      <div class="contact-card">
        <div class="icon-wrapper">
          <img src="../assets/img/callus/add.png" alt="地址图标" />
        </div>
        <h3>公司地址</h3>
        <div class="info-content">
          <p class="main-info">福建省福州市闽清县闽江大道9号锦绣闽江7栋D148号</p>
          <p class="sub-info">欢迎前来参观洽谈</p>
        </div>
        <a href="https://maps.baidu.com/search/%E7%A6%8F%E5%BB%BA%E7%9C%81%E7%A6%8F%E5%B7%9E%E5%B8%82%E9%97%BD%E6%B8%85%E5%8E%BF%E9%97%BD%E6%B1%9F%E5%A4%A7%E9%81%939%E5%8F%B7%E9%94%A6%E7%BB%A3%E9%97%BD%E6%B1%9F1%E6%9C%9F7%E6%A0%8B/@13235751.925,3005242.83,19z?querytype=s&da_src=shareurl&wd=%E7%A6%8F%E5%BB%BA%E7%9C%81%E7%A6%8F%E5%B7%9E%E5%B8%82%E9%97%BD%E6%B8%85%E5%8E%BF%E9%97%BD%E6%B1%9F%E5%A4%A7%E9%81%939%E5%8F%B7%E9%94%A6%E7%BB%A3%E9%97%BD%E6%B1%9F1%E6%9C%9F7%E6%A0%8B&c=300&src=0&pn=0&sug=0&l=19&b=(13235350.251007086,3005044.1318205;13236203.751007086,3005501.6318205)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&device_ratio=2" target="_blank" class="action-link">
          查看地图
          <img src="../assets/img/callus/mouse.png" alt="点击图标" class="mouse-icon" />
        </a>
      </div>

      <div class="contact-card">
        <div class="icon-wrapper">
          <img src="../assets/img/callus/wechat.png" alt="微信图标" />
        </div>
        <h3>微信公众号</h3>
        <div class="info-content qrcode-container">
          <img src="../assets/img/minjiangqr.jpg" alt="公司微信公众号二维码" class="qrcode">
          <p class="sub-info">扫码关注获取更多资讯</p>
        </div>
        <p class="wechat-name">公众号：闽江智能数据标注产业基地</p>
      </div>
    </div>
    <div class="zbpt-entry">
      <router-link class="to-zbpt-btn" to="/zbpt">
        <span>注册成为我们的合作伙伴</span>
        <svg class="btn-arrow" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M5 12h12m-5-5 5 5-5 5" />
        </svg>
      </router-link>
    </div>

  </div>
</template>

<script>
export default {
  name: 'ContactInfoPage'
};
</script>

<style scoped>
.contact-page {
  max-width: 1400px;
  margin: 0 auto;
  padding: 60px 20px;
  font-family: 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  color: #333;
}

.page-header {
  text-align: center;
  margin-bottom: 60px;
}

.page-header h1 {
  font-size: 2.5rem;
  color: #2c3e50;
  margin-bottom: 15px;
  font-weight: 700;
}

.page-header p {
  font-size: 1.1rem;
  color: #666;
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
}

.contact-container {
  display: flex;
  gap: 30px;
  margin-bottom: 80px;
  justify-content: center;
  flex-wrap: wrap;
}

.contact-card {
  flex: 1;
  min-width: 250px;
  max-width: 300px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.05);
  padding: 35px 30px;
  transition: all 0.3s ease;
  border-top: 4px solid #2980b9;
  display: flex;
  flex-direction: column;
}

.contact-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 12px 20px rgba(0, 0, 0, 0.1);
}

.icon-wrapper {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #ebf5fb;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 25px;
}

.icon-wrapper img {
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.contact-card h3 {
  font-size: 1.25rem;
  color: #2c3e50;
  margin: 0 0 20px;
  font-weight: 600;
}

.info-content {
  margin-bottom: 25px;
  flex-grow: 1;
}

.main-info {
  font-size: 1.1rem;
  color: #34495e;
  margin: 0 0 10px;
  line-height: 1.6;
}

.sub-info {
  font-size: 0.9rem;
  color: #7f8c8d;
  margin: 0;
  line-height: 1.5;
}

.action-link {
  display: inline-flex;
  align-items: center;
  color: #2980b9;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.95rem;
  transition: color 0.3s ease;
  margin-top: auto;
  align-self: flex-start;
}

.action-link:hover {
  color: #1f6dad;
}

.action-link i {
  font-size: 0.8rem;
  margin-left: 5px;
  transition: transform 0.3s ease;
}

.action-link:hover i {
  transform: translateX(3px);
}

.mouse-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
  margin-left: 6px;
}

.qrcode-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.qrcode {
  width: 140px;
  height: 140px;
  border: 1px solid #eee;
  padding: 8px;
  margin-bottom: 15px;
  border-radius: 6px;
}

.wechat-name {
  font-size: 0.95rem;
  color: #34495e;
  text-align: center;
  margin-top: auto;
  font-weight: 500;
}

.clickable {
  cursor: pointer;
  transition: all 0.2s ease;
}

.clickable:hover {
  opacity: 0.9;
}

.zbpt-entry {
  text-align: center;
}

.to-zbpt-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 306px;
  height: 30px;
  padding: 12px 30px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  background: linear-gradient(90deg, rgb(4,96,183), rgb(4,67,126));
  color: #fff;
  text-decoration: none;
  font-size: 24px;
  font-weight: 500;
  box-shadow: 0 8px 22px rgba(34, 71, 218, 0.28);
  transition: transform 0.28s ease, box-shadow 0.28s ease, filter 0.28s ease;
}

.btn-arrow {
  margin-left: 8px;
  width: 24px;
  height: 24px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2.2;
  stroke-linecap: round;
  stroke-linejoin: round;
  transition: transform 0.28s ease;
}

.to-zbpt-btn:hover {
  transform: translateY(-2px) scale(1.03);
  box-shadow: 0 14px 30px rgba(34, 71, 218, 0.35);
  filter: brightness(1.05);
}

.to-zbpt-btn:hover .btn-arrow {
  transform: translateX(3px);
}

.to-zbpt-btn:active {
  transform: translateY(0) scale(0.99);
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .contact-container {
    gap: 25px;
  }
  
  .contact-card {
    max-width: 270px;
  }
}

@media (max-width: 992px) {
  .contact-container {
    flex-wrap: wrap;
  }
  
  .contact-card {
    flex: 1 1 calc(50% - 25px);
    max-width: none;
  }
}

@media (max-width: 768px) {
  .page-header h1 {
    font-size: 2rem;
  }
  
  .contact-card {
    flex: 1 1 100%;
  }
  
  .map-section {
    margin-top: 30px;
  }
}

@media (max-width: 576px) {
  .contact-page {
    padding: 40px 15px;
  }
  
  .page-header {
    margin-bottom: 40px;
  }
  
  .icon-wrapper {
    width: 50px;
    height: 50px;
  }
  
  .icon-wrapper img {
    width: 22px;
    height: 22px;
  }
}
</style>
    
